import { Module } from 'vuex';
import { RootState } from './types';
import { SubmissionService } from '@/api/SubmissionService';
import { Submission } from '@/api/index.defs';

interface SubmissionState {
  submission?: Submission | null;
}

export const state: SubmissionState = {
    submission: null
};

const mutations = {
    setSubmission (state: SubmissionState, submission: Submission) {
      state.submission = submission || null;
    },
    setIsEditingRenewalApplication (state: SubmissionState) {
        state.submission.IsEditingRenewalApplication = true;
    },
    setDistributionDetailsSubmitForFirmQuote (state: SubmissionState) {
      if (state.submission.IsDistributionRequest &&
         (state.submission.DistributionDetails.SubmitForFirmQuote === null || state.submission.DistributionDetails.SubmitForFirmQuote === undefined)) {
        state.submission.DistributionDetails.SubmitForFirmQuote = new Date();
      }
    },
    setSelectedQuoteId (state: SubmissionState, quoteId: string) {
      state.submission.SelectedQuoteId = quoteId;
    }
};

const getters = {
    getSubmission (state: SubmissionState) {
        return state.submission;
    },
    isRenewalSubmission (state: SubmissionState) {
      return state.submission && state.submission.Renewal;
    }
};

export const actions = {
    async setIsEditingRenewalApplication ({ commit }: any) {
      commit('setIsEditingRenewalApplication');
    },
    async setSelectedQuoteId ({ commit }: any, quoteId: string) {
      commit('setSelectedQuoteId', quoteId);
    },
    async getSubmission ({ commit }: any, id: string) {
        try {
          // @ts-ignore
          const submission = await SubmissionService.get({ id }, { handleError: false });
          commit('setSubmission', submission);
          return state.submission;
        } catch (error) {
          return null;
        }
    },
    async setSubmission ({ commit }: any, submission: Submission) {
      commit('setSubmission', submission);
      return submission;
    },
    async saveSubmissionForGate ({ commit, dispatch }: any) {
      commit('setDistributionDetailsSubmitForFirmQuote');
      return await dispatch('saveSubmissionPreGate');
    },
    async saveSubmissionPreGate ({ commit, state }: any) {
      let submission = null;
      if (state.submission.InitialForm === 'Flood') {
        submission = await SubmissionService.savePreGateV1({
          body: state.submission
        });
      } else {
        submission = await SubmissionService.savePreGate({
          body: state.submission
        });
      }

      commit('setSubmission', submission);
      return submission;
    },
    async setAgentDetails ({ state }: any, { orgId, orgBranchId, humanId }: any) {
      state.submission.OrgId = orgId;
      state.submission.OrgBranchId = orgBranchId;
      state.submission.HumanId = [humanId];
    },
    async saveSubmission ({ commit, state }: any) {
      let submission = null;
      if (state.submission.InitialForm !== 'HO' && state.submission.InitialForm !== 'Flood') {
        // only save the submission for HO/Flood- prevents overwriting the submission for other forms that do not use SubmissionData
        return submission;
      }
      if (state.submission.CurrentForm !== 'HO' && state.submission.CurrentForm !== 'BindV2' &&
         state.submission.CurrentForm !== 'Flood' && state.submission.CurrentForm !== 'BindV1') {
        // only save the submission for HO/Flood- prevents overwriting the submission for other forms that do not use SubmissionData
        return submission;
      }
      if (state.submission.InitialForm === 'Flood') {
        submission = await SubmissionService.saveV1({
          body: state.submission
        });
      } else {
        submission = await SubmissionService.save({
          body: state.submission
        });
      }

      commit('setSubmission', submission);
      return submission;
    },
    setEmptySubmissionData ({ commit }: any) {
      commit('setSubmission', { Data: {} });
    },
    clearSubmission ({ commit }: any) {
      commit('setSubmission', null);
  }
};

const namespaced: boolean = true;

export const submissionState: Module<SubmissionState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
